import React from "react";
import List from "react-md/lib/Lists/List";
import ListItem from "react-md/lib/Lists/ListItem";
import FontIcon from "react-md/lib/FontIcons";
import { map } from "lodash";

const ListComponent = ({ items, leftAvatar, className }) => {
  return (
    <List className={`md-paper--1 shadow-none ${className}`}>
      {map(items, (item, i) => (
        <ListItem
          key={i}
          leftAvatar={leftAvatar}
          rightIcon={
            <FontIcon className="delete" onClick={() => item.onClick()}>
              delete
            </FontIcon>
          }
          primaryText={item.primary}
          secondaryText={item.secondary}
          className="list"
        />
      ))}
    </List>
  );
};

export default ListComponent;



// WEBPACK FOOTER //
// ./src/components/settings/organizationEdit/List.js